/*eslint-disable*/
import { createSlice } from '@reduxjs/toolkit'

// actions
import { getGroups } from '../actions/groups'

const initialState = {
    status: 'idle',
    error: null,
    filteredGroups: [],
  }

export const groupsSlice = createSlice({
    name: 'groups',
    initialState,
    reducers: {
      resetFilteredGroups: (state) => {
        state.filteredGroups = []
      },
    },
    extraReducers(builder) {
      builder
        .addCase(getGroups.pending, (state) => {
          state.status = 'loading'
          state.error = undefined
        })
        .addCase(getGroups.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.error = undefined
          state.filteredGroups = [...action.payload.resources]
        })
        .addCase(getGroups.rejected, (state, action) => {
          state.status = 'failed'
          state.error = action.error.message
        })
    },
  })

  export const { resetFilteredGroups } = groupsSlice.actions

  export default groupsSlice.reducer
